<template>
  <base-section id="theme-features" space="10">
    <v-container>
      <v-row class="ml-2 mr-2">
        <v-col cols="12">
          <base-section-heading
            :title="$t('home.text.title')"
            icon="mdi-help-network-outline"
            :text="$t('home.html.title')"
          />
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <v-row class="ml-2 mr-2">
        <v-col v-for="(feature, i) in features" :key="i" cols="12" md="6">
          <base-avatar-card
            :title="feature.title"
            :icon="feature.icon"
            :text="feature.text"
            align="left"
            horizontal
          >
            <p v-text="feature.html.text" style="margin: 2px" />
            <b v-text="feature.html.bold" />
            <ul>
              <li
                v-for="item in feature.html.items"
                :key="item"
                v-text="item"
              />
            </ul>
            <v-chip v-if="feature.to" class="mr-2 mt-2" @click="navigateTo(feature.to)" color="primary" >
              <span style="color:white;" v-text="$t('home.go_to')" />
              <v-icon color="white" right>mdi-arrow-right-bold</v-icon>
            </v-chip>
          </base-avatar-card>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
export default {
  name: 'ProcessFeatures',

  methods: {
    navigateTo (path) {
      this.$router.push(path)
    }
  },

  computed: {
    features () {
      return [
        {
          title: this.$t('keywords.api_query'),
          icon: 'mdi-weather-cloudy-arrow-right',
          html: {
            text: this.$t('home.html.api_query.text'),
            items: this.$t('home.html.api_query.items')
          },
          to: '/consulta-apis'
        },
        {
          title: this.$t('keywords.rest_to_soap'),
          icon: 'mdi-cloud-tags',
          html: {
            text: this.$t('home.html.rest_to_soap.text'),
            items: this.$t('home.html.rest_to_soap.items')
          },
          to: '/rest-to-soap'
        },
        {
          title: this.$t('keywords.send_data.rest'),
          icon: 'mdi-code-json',
          html: {
            text: this.$t('home.html.send_data_by.rest'),
            items: this.$t('home.html.send_data_by.items')
          },
          to: '/job-envia-dados-rest'
        },
        {
          title: this.$t('keywords.send_data.soap'),
          icon: 'mdi-code-tags',
          html: {
            text: this.$t('home.html.send_data_by.soap'),
            items: this.$t('home.html.send_data_by.items')
          },
          to: '/job-envia-dados-soap'
        },
        {
          title: this.$t('keywords.workflow'),
          icon: 'mdi-clipboard-flow-outline',
          html: {
            text: this.$t('home.html.workflow.text'),
            bold: this.$t('home.html.workflow.bold'),
            items: this.$t('home.html.workflow.items')
          },
          to: '/workflow'
        },
        {
          title: this.$t('keywords.monitoring'),
          icon: 'mdi-clipboard-pulse-outline',
          html: {
            text: this.$t('home.html.monitoring.text'),
            items: this.$t('home.html.monitoring.items')
          },
          to: this.$versionable.decorators.monitoring.path
        },
        {
          color: 'primary',
          dark: true,
          title: this.$t('home.text.easy_custom'),
          icon: 'mdi-pencil-box-outline',
          html: {
            text: this.$t('home.html.easy_custom')
          }
        }
      ]
    }
  }

}
</script>
